/**
 * StudentCloseAccountScreen — « Fermer mon compte » (route `account-close`), à la place de
 * `student/account/DeleteAccountScreen.js` quand l'espace élève est allumé.
 *
 * Patron C : l'avis d'abonnement se lit dans le compte déjà là (`studentCloseAccountViewModel`) ; la
 * confirmation et la suppression vivent dans `useStudentCloseAccountState`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentCloseAccountPage } from "../../../../../../design-system/student"
import { studentCloseAccountViewModel } from "../../../../view-models/student/Account/studentCloseAccountViewModel"
import { useStudentCloseAccountState } from "./useStudentCloseAccountState"

export function StudentCloseAccountScreen() {
    const vm = useSelector(studentCloseAccountViewModel)
    const state = useStudentCloseAccountState()

    return <StudentCloseAccountPage activeOffer={vm.activeOffer} {...state} />
}
